// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/styles/global/index.global.scss
// module id = JCTc
// module chunks = 0